import React from "react";
import { Box, Button, Typography, Stack, Container } from "@mui/material";
import AppButton from "../../components/app-button/AppButton";
import Iconify from "../../components/iconify/Iconify";

const TableViewEmptyState = ({ onTableClick }) => {
  return (
    <Box
      sx={{
        minHeight: 420,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        border: "1px dashed #e0e0e0",
        marginTop: 4,
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box textAlign="center">
          {/* Illustration */}
          <Box
            sx={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              backgroundColor: "#E8F5E9",
              border: "1px solid #2E7D32",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <Iconify
              icon="material-symbols:table-restaurant-outline-rounded"
              width={64}
              color="#2E7D32"
            />
          </Box>

          {/* Title */}
          <Typography
            variant="h5"
            fontWeight={700}
            color="text.primary"
            gutterBottom
          >
            No Tables Configured
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mb: 4,
              maxWidth: 680,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Your restaurant floor plan is empty.
            <br />
            Create areas like <b>Garden</b> or <b>Rooftop</b> and add tables to
            start managing dine-in orders.
          </Typography>

          {/* Primary CTA */}
          <AppButton
            onClick={onTableClick}
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            Configure Tables
          </AppButton>
        </Box>
      </Container>
    </Box>
  );
};

export default TableViewEmptyState;
